import classNames from "classnames"
import { FormSection as FormSectionType } from "../../types/FormSection"
import { FormRow } from "../FormRow"

export interface Props {
  section: FormSectionType
  isHidden?: boolean
}

export function FormSection({ section, isHidden }: Props) {
  return (
    <div
      id={section.section_name}
      className={classNames("pb-4", {
        hidden: isHidden,
      })}
    >
      <h2 className="[font-size:var(--alias-font-display-xl-font-size)] [font-family:var(--alias-font-display-xl-font-family)] pb-[var(--alias-padding-base)]">
        {section.section_name}
      </h2>
      <p className="[font-size:var(--alias-font-subtitle-lg-font-size)] text-[color:var(--alias-color-text-weaker)] [font-family:var(--alias-font-subtitle-lg-font-weight)] pb-[58px]">
        {section.section_description}
      </p>
      {section.form_rows.map((row) => (
        <FormRow key={row.order} row={row} sectionName={section.section_name} />
      ))}
    </div>
  )
}
